/* custom code start */
if (!customElements.get("home-shop-the-look")) {
  class HomeShopTheLook extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll(".hstl-tab"));
      this.looks = Array.from(this.querySelectorAll(".hstl-look"));
      this.hotspots = Array.from(this.querySelectorAll(".hstl-hotspot"));

      this.onTabClick = this.onTabClick.bind(this);
      this.onDotClick = this.onDotClick.bind(this);
      this.onDocClick = this.onDocClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.tabs.forEach((tab) => tab.addEventListener("click", this.onTabClick));
      this.hotspots.forEach((spot) => {
        const dot = spot.querySelector(".hstl-dot");
        if (dot) dot.addEventListener("click", this.onDotClick);
      });
      document.addEventListener("click", this.onDocClick);
      this.addEventListener("keydown", this.onKeydown);
      this.addEventListener("shopify:block:select", this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener("click", this.onDocClick);
    }

    onTabClick(event) {
      this.activateTab(event.currentTarget.dataset.tab);
    }

    activateTab(id) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.tab === id;
        tab.classList.toggle("is-active", isActive);
        tab.setAttribute("aria-selected", isActive ? "true" : "false");
      });
      this.looks.forEach((look) => {
        look.classList.toggle("is-active", look.dataset.tab === id);
      });
      this.closeAll();
    }

    onDotClick(event) {
      event.preventDefault();
      event.stopPropagation();
      const spot = event.currentTarget.closest(".hstl-hotspot");
      const isOpen = spot.classList.contains("is-open");
      this.closeAll();
      if (!isOpen) {
        spot.classList.add("is-open");
        event.currentTarget.setAttribute("aria-expanded", "true");
      }
    }

    onDocClick(event) {
      if (!this.contains(event.target)) this.closeAll();
    }

    onKeydown(event) {
      if (event.key === "Escape") this.closeAll();
    }

    closeAll() {
      this.hotspots.forEach((spot) => {
        spot.classList.remove("is-open");
        const dot = spot.querySelector(".hstl-dot");
        if (dot) dot.setAttribute("aria-expanded", "false");
      });
    }

    onBlockSelect(event) {
      const look = event.target.closest(".hstl-look");
      if (look) this.activateTab(look.dataset.tab);
    }
  }

  customElements.define("home-shop-the-look", HomeShopTheLook);
}
/* custom code end */
